export default __webpack_public_path__ + "a1c6e906822b53187347381130be28e4.png";